export default __webpack_public_path__ + "static/media/hnk.9a2cc8ff.mp4";